import '../../assets/index6.css';var P = Object.defineProperty, k = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var u = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var c = (a, t, e) => t in a ? P(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e, d = (a, t) => {
  for (var e in t || (t = {}))
    u.call(t, e) && c(a, e, t[e]);
  if (n)
    for (var e of n(t))
      p.call(t, e) && c(a, e, t[e]);
  return a;
}, f = (a, t) => k(a, z(t));
var h = (a, t) => {
  var e = {};
  for (var r in a)
    u.call(a, r) && t.indexOf(r) < 0 && (e[r] = a[r]);
  if (a != null && n)
    for (var r of n(a))
      t.indexOf(r) < 0 && p.call(a, r) && (e[r] = a[r]);
  return e;
};
import { jsx as o, jsxs as g } from "react/jsx-runtime";
import w, { forwardRef as y } from "react";
import { Flex as j } from "../../components/Flex/index.js";
import { Group as N } from "../../components/Group/index.js";
import { c as F } from "../../factory-ueRxoNOV.js";
import { Button as B } from "../../components/Button/index.js";
import { Text as I } from "../../components/Text/index.js";
import { ArrowLeftFAIcon as D } from "../../components/Icons/index.js";
const G = "PageNavigation-module__root___aDzA-", L = "PageNavigation-module__container___IDieJ", R = "PageNavigation-module__backButton___I310z", $ = "PageNavigation-module__title___Lgdb4", J = "PageNavigation-module__noBackButton___-C2lM", l = {
  root: G,
  container: L,
  backButton: R,
  title: $,
  noBackButton: J
}, M = y((T, x) => {
  var s = T, {
    title: a,
    onBackClick: t,
    classNames: e,
    actions: r,
    componentActions: i,
    "data-plum-id": v
  } = s, b = h(s, [
    "title",
    "onBackClick",
    "classNames",
    "actions",
    "componentActions",
    "data-plum-id"
  ]);
  return /* @__PURE__ */ o(
    "div",
    f(d({
      ref: x,
      className: F(
        l.root,
        e,
        !t && l.noBackButton
      ),
      "data-plum-id": v
    }, b), {
      children: /* @__PURE__ */ o("div", { className: l.container, children: /* @__PURE__ */ g(j, { gap: "xxs", w: "100%", children: [
        t && /* @__PURE__ */ o(
          B,
          {
            variant: "tertiary",
            "aria-label": "Go back",
            size: "md",
            onClick: t,
            color: "gray",
            className: l.backButton,
            children: /* @__PURE__ */ o(D, { size: 16 })
          }
        ),
        /* @__PURE__ */ g(N, { justify: "space-between", align: "center", w: "100%", children: [
          /* @__PURE__ */ o(
            I,
            {
              className: l.title,
              component: "h1",
              size: "1.25rem",
              lh: 1.5,
              children: a
            }
          ),
          (r && r.length > 0 || i && i.length > 0) && /* @__PURE__ */ g(N, { gap: "xs", children: [
            r == null ? void 0 : r.map((m, _) => /* @__PURE__ */ o(
              B,
              d({
                size: "sm"
              }, m),
              `button-${_}`
            )),
            i == null ? void 0 : i.map((m, _) => /* @__PURE__ */ o(w.Fragment, { children: m }, `component-${_}`))
          ] })
        ] })
      ] }) })
    })
  );
});
M.displayName = "PageNavigation";
export {
  M as PageNavigation
};
